export enum UserPermission {
    'guest' = 'guest',
    'user' = 'user',
    'admin' = 'admin'
}

const PERMISSION_HIERARCHY = [
    UserPermission.guest,
    UserPermission.user,
    UserPermission.admin
] as const

export function get_permissions_up_to(permission: UserPermission | string): UserPermission[] {
    const index = PERMISSION_HIERARCHY.indexOf(permission as UserPermission)
    return index === -1 ? [] : PERMISSION_HIERARCHY.slice(0, index + 1)
}
